// extracted by mini-css-extract-plugin
export var big_text = "FullWidthBlock-module--big_text--8dcfe";
export var brandBg = "FullWidthBlock-module--brandBg--be061";
export var content = "FullWidthBlock-module--content--51824";
export var fancy_bg_text = "FullWidthBlock-module--fancy_bg_text--eb4eb";
export var full_width_block = "FullWidthBlock-module--full_width_block--f2c0b";